// Remembers the last lesson the user was studying so the home page can
// surface a "ادامه مطالعه" (continue studying) card. Stored in localStorage
// so it survives reloads/sessions.

export interface LastStudied {
  courseId: string;
  lessonId: string;
  miniAppUuid: string;
  courseTitle: string;
  lessonTitle?: string;
  coverUrl?: string;
  lessonsCount?: number;
  /** Real course progress from the API (0–100), when available. */
  progressPercentage?: number;
  updatedAt: number;
}

const KEY = "last_studied";

export function setLastStudied(record: LastStudied): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(record));
  } catch {
    /* storage unavailable — ignore */
  }
}

export function getLastStudied(): LastStudied | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as LastStudied;
    if (!parsed?.courseId || !parsed?.lessonId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearLastStudied(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
